export default __webpack_public_path__ + "static/media/330_dummy2016-schneiderei01-de.a88fc7e1.png";